/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link } from "react-router-dom";
import { BreadcrumbComponentProps } from "./breadcrumb-component-props";
import Logo from "../../../assets/icons/breadcrumb-logo.svg";
import "./breadcrumb-component.scss";
import { useLogin } from "../../hooks/useUser";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
  event.preventDefault();
}

const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = ({
  breadcrumbLink,
  showBackArrow = false,
}) => {
  const navigate = useNavigate();
  const tenantDetails = useLogin();
  const tenantLogoUrl = tenantDetails?.tenantDetails?.thumbnailUrlTwo;

  return (
    <div className="breadcrumb-component">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {showBackArrow && (
          <IconButton onClick={() => navigate(-1)} aria-label="Go Back">
            <ArrowBackOutlinedIcon />
          </IconButton>
        )}

        <Stack spacing={2}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbLink?.map((linkData: any, index: any) => {
              const isLast = index === breadcrumbLink.length - 1;

              if (isLast) {
                return (
                  <Typography key={index} sx={{ color: "text.primary" }}>
                    {linkData?.label}
                  </Typography>
                );
              }

              if (linkData?.handleClick) {
                return (
                  <span
                    key={index}
                    className="breadcrumb-link"
                    onClick={linkData.handleClick}
                  >
                    {linkData.label}
                  </span>
                );
              }
              if (linkData?.link) {
                return (
                  <Link
                    key={index}
                    to={linkData.link}
                    className="breadcrumb-link"
                  >
                    {linkData.label}
                  </Link>
                );
              }

              return (
                <Typography key={index} sx={{ color: "text.secondary" }}>
                  {linkData.label}
                </Typography>
              );
            })}
          </Breadcrumbs>
        </Stack>
      </div>
      <img src={tenantLogoUrl ? tenantLogoUrl : Logo} alt="logo" />
    </div>
  );
};

export default BreadcrumbComponent;
